import { useEffect, useRef } from "react";
import { createPortal } from "react-dom";

export const TableauPortal = ({ token }: { token: string }) => {
  const vizContainerRef = useRef(document.createElement("div"));
  const tableauVizRef = useRef<Element | null>(null);

  // Initialize Tableau only once
  useEffect(() => {
    if (!tableauVizRef.current) {
      const tableauEl = document.createElement("tableau-viz");
      tableauEl.setAttribute("id", "tableau-viz");
      tableauEl.setAttribute("token", token);
      tableauEl.setAttribute(
        "src",
        "https://us-east-1.online.tableau.com/t/cimpar/views/CPSVaccineDashboard/Main"
      );
      tableauEl.setAttribute("width", "100%");
      tableauEl.setAttribute("height", "calc(100dvh - 14rem)");
      tableauEl.setAttribute("hide-tabs", "");
      tableauEl.setAttribute("toolbar", "bottom");

      tableauVizRef.current = tableauEl;
      vizContainerRef.current.appendChild(tableauEl);
    }
  }, [token]);

  // Append container once to root container
  useEffect(() => {
    const root = document.getElementById("tableau-container-root");
    if (root) {
      // Check if <tableau-viz> already exists in the container
      const alreadyHasTableau = root.querySelector("tableau-viz");

      if (!alreadyHasTableau && !root.contains(vizContainerRef.current)) {
        root.appendChild(vizContainerRef.current);
      }
    }
  }, []);

  return createPortal(null, vizContainerRef.current);
};

export function cleanUpTableauViz() {
  const root = document.getElementById("tableau-container-root");
  const container = root?.querySelector("#tableau-viz")?.parentElement;

  if (container && root?.contains(container)) {
    root.removeChild(container);
  }
}
